<template>
  <div>
    <!-- Réglages notifications par niveau -->
    <div class="card card-flush mb-6">
      <div class="card-body py-4">
        <h6 class="mb-4">{{ $t('landlord.tickets.settings_title') }}</h6>
        <div class="d-flex flex-wrap gap-8">
          <div v-for="setting in supportSettings" :key="setting.priority" class="d-flex align-items-center gap-4">
            <span class="badge" :class="priorityBadgeClass(setting.priority)">
              {{ $t('landlord.tickets.priority_' + setting.priority) }}
            </span>
            <div class="form-check form-switch mb-0">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'email-' + setting.priority"
                v-model="setting.email_enabled"
                @change="onSettingChange(setting)"
              />
              <label class="form-check-label" :for="'email-' + setting.priority">{{ $t('landlord.tickets.settings_email') }}</label>
            </div>
            <div class="form-check form-switch mb-0">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'whatsapp-' + setting.priority"
                v-model="setting.whatsapp_enabled"
                @change="onSettingChange(setting)"
              />
              <label class="form-check-label" :for="'whatsapp-' + setting.priority">{{ $t('landlord.tickets.settings_whatsapp') }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Coordonnées de réception -->
    <div class="card card-flush">
      <div class="card-body py-4">
        <h6 class="mb-4">{{ $t('landlord.tickets.contact_title') }}</h6>
        <div class="row g-4 align-items-end">
          <div class="col-md-5">
            <label class="form-label fs-7">{{ $t('landlord.tickets.contact_email') }}</label>
            <input v-model="contactForm.notification_email" type="email" class="form-control form-control-sm" placeholder="vous@exemple.com" />
          </div>
          <div class="col-md-5">
            <label class="form-label fs-7">{{ $t('landlord.tickets.contact_whatsapp') }}</label>
            <input v-model="contactForm.whatsapp_number" type="text" class="form-control form-control-sm" placeholder="+229xxxxxxxx" />
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-sm btn-primary w-100" :disabled="savingContact" @click="saveContact">
              {{ $t('landlord.tickets.contact_save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LandlordSettingsSupport',
  data() {
    return {
      savingContact: false,
      contactForm: {
        notification_email: '',
        whatsapp_number: ''
      }
    }
  },
  computed: {
    ...mapGetters('landlord', ['supportSettings', 'supportContactSettings'])
  },
  mounted() {
    this.fetchSupportSettings()
    this.fetchSupportContactSettings().then(() => {
      this.contactForm.notification_email = this.supportContactSettings?.notification_email || ''
      this.contactForm.whatsapp_number = this.supportContactSettings?.whatsapp_number || ''
    })
  },
  methods: {
    ...mapActions('landlord', [
      'fetchSupportSettings', 'updateSupportSetting',
      'fetchSupportContactSettings', 'updateSupportContactSettings'
    ]),

    priorityBadgeClass(priority) {
      return {
        low: 'badge-light-secondary',
        normal: 'badge-light-primary',
        high: 'badge-light-dark',
        critical: 'badge-light-danger'
      }[priority] || 'badge-light-primary'
    },

    onSettingChange(setting) {
      this.updateSupportSetting({
        priority: setting.priority,
        data: {
          email_enabled: setting.email_enabled,
          whatsapp_enabled: setting.whatsapp_enabled
        }
      }).then(() => {
        window.toastr['success'](this.$t('landlord.tickets.settings_updated'))
      })
    },

    saveContact() {
      this.savingContact = true
      this.updateSupportContactSettings(this.contactForm).then(() => {
        window.toastr['success'](this.$t('landlord.tickets.contact_saved'))
      }).finally(() => {
        this.savingContact = false
      })
    }
  }
}
</script>
